import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useGlobalStore } from "@/store/GlobalStore";

enum MoneyType {
  rmbCumulative = 1,
  usdCumulative = 2,
}

interface IDiscount {
  discount: number;
  dyyRmbCumulative: number;
  dyyUsdCumulative: number;
  gpuDiscount: number;
  id: number;
  level: number;
  rmbCumulative: number;
  usdCumulative: number;
  usdDiscount: number;
  usdGpuDiscount: number;
}

export function useMemberSystem() {
  const [currenProgress, setCurrentProgress] = useState(0);
  const [progressbar, setProgressbar] = useState<number>(0);
  const [nextLevel, setNextLevel] = useState<number>(0);
  const { userInfo } = useGlobalStore();

  const [percent, setPercent] = useState(0);

  const { data } = useQuery<IDiscount[]>([
    "/api/rendering/user/queryPriceDiscount",
  ]);
  useEffect(() => {
    if (!data || !userInfo) return;

    const moneyType = MoneyType[userInfo.zone!] as
      | "rmbCumulative"
      | "usdCumulative";
    setCurrentProgress(userInfo[moneyType] || 0);

    const nextLevel = data.find((i) => i.level > (userInfo.level || -1));
    setProgressbar(nextLevel ? nextLevel[moneyType] : userInfo[moneyType] || 0);
    setNextLevel(
      nextLevel && !userInfo.tempMemberValidityTime ? nextLevel.level : -1
    );
  }, [data, userInfo]);

  useEffect(() => {
    let percent = (currenProgress / Number(progressbar)) * 100;

    if (percent < 0) {
      percent = 0;
    }
    if (percent > 100) {
      percent = 100;
    }
    setPercent(percent);
  }, [currenProgress, progressbar]);

  return { currenProgress, progressbar, percent, nextLevel };
}
